export const validateTriggerForm = (values, offerDaysValues) => {
  const errors = {};

  if (!values.selectedOfferType) {
    errors.selectedOfferType = "Offer type is required!";
  }

  if (!values.selectedPlanDuration) {
    errors.selectedPlanDuration = "Plan duration is required!";
  }

  if (!values.selectedCategory) {
    errors.selectedCategory = "Offer category is required!";
  }

  offerDaysValues.forEach((offerDay, index) => {
    const dayErrors = {};

    if (!offerDay.selectedOffers?.length) {
      dayErrors.selectedOffers = "Offers are required!";
    }

    if (
      offerDay.selectedOffers?.some(
        (offer) => offer?.info?.value === "extent_days"
      ) &&
      !offerDay.extendableDays
    ) {
      dayErrors.extendableDays = "Extendable days is required!";
    }

    if (
      offerDay.selectedOffers?.some(
        (offer) => offer?.info?.value === "voucher"
      ) &&
      !offerDay.offerVoucherCode
    ) {
      dayErrors.offerVoucherCode = "Voucher code is required!";
    }

    if (
      offerDay.selectedOffers?.some(
        (offer) => offer?.info?.value === "cash_back"
      ) &&
      !offerDay.cashbackAmount
    ) {
      dayErrors.cashbackAmount = "Cashback amount is required!";
    }

    if (
      offerDay.selectedOffers?.some(
        (offer) => offer?.info?.value === "goodies"
      ) &&
      !offerDay.selectedGoodies?.length
    ) {
      dayErrors.selectedGoodies = "Goodies are required!";
    }

    if (
      offerDay.selectedOffers?.some((offer) => offer?.info?.extent_days) &&
      !offerDay.extendableDays
    ) {
      dayErrors.extendableDays = "Extendable days is required!";
    }

    Object.entries(offerDay).forEach(([key, value]) => {
      if (
        ![
          "selectedOffers",
          "offerVoucherCode",
          "cashbackAmount",
          "selectedGoodies",
          "extendableDays",
        ].includes(key) &&
        !value
      ) {
        dayErrors[key] = `${key} is required!`;
      }
    });

    if (Object.keys(dayErrors).length > 0) {
      errors[index] = dayErrors;
    }
  });

  return errors;
};

export const validateInventoryForm = (values) => {
  let errors = {};

  if (!values.inventoryName) {
    errors.inventoryName = "Inventory name is required!";
  }

  if (!values.inventoryImage) {
    errors.inventoryImage = "Inventory image is required!";
  }

  return errors;
};
